var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('masked-input',{staticClass:"el-input__inner",attrs:{"type":"text","mask":_vm.dateMask,"guide":false,"required":!!_vm.required,"disabled":!!_vm.disabled,"placeholder":_vm.placeholder},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }